module.exports = __webpack_public_path__ + "static/media/rereplanet.47c4ea22.jpg";